// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3ZO_J","cell":"ColumnAccessor_cell__168sU","firstCellAccent":"ColumnAccessor_firstCellAccent__1nrVZ"};